import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { SalesDistributionService } from "app/modules/components/assistant/sales-distribution/sales-distribution.service";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { OrderListTableComponent } from "../../../order-list-table/order-list-table.component";
import { getCode } from "app/utils/method";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { PrincipalScreenService } from "../../../principal-screen/principal-screen.service";
import { UpdateOrderService } from "app/modules/components/sales/update-order/update-order.service";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule } from "@angular/material/menu";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { UnitOfMeasureEnum } from "app/common/enums/unit-of-measure.enum";

@Component({
  selector: "app-distribution-material",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    DecimalFormatPipe,
    MatDialogModule,
    OrderListTableComponent,
    MatMenuModule,
    HoverMenuDirective,
    UnitMeasureDisplayComponent
  ],
  templateUrl: "./distribution-material.component.html",
  styleUrl: "./distribution-material.component.scss"
})
export class DistributionMaterialComponent {
  @Input() expandedMaterial: any = null;
  @Input() UMPActive: boolean = false;
  @Output() closeDrawer: EventEmitter<any> = new EventEmitter<any>();

  getCode = getCode;
  StatusEnum = StatusEnum
  selectedMaterialDoc:any = null
  public displayColumsDistributionItems: string[] = [
    //"isNew",
    "note",
    "noDto",
    "client",
    "soldQuantity",
    "det",
  ];

  @ViewChild("viewDocumentModal") viewDocumentModal!: TemplateRef<any>;
  @ViewChild("unitMeasureModal") unitMeasureModal!: TemplateRef<any>;
  @ViewChild('soldToEmptyDocument') soldToEmptyDocument!: TemplateRef<any>;
  dialogReEdit: MatDialogRef<any>;
  unitMeasureModalRef: MatDialogRef<any> | null = null;
  soldToEmptyDialogRef: MatDialogRef<any> | null = null;

  detailOrderUnified = []
  soldToList: any[] = [];
  selectedSoldTo: any = null;
  detail: any = {
    selectedUnit: null,
    baseQuantity: null,
    pararellQuantity: null
  };

  constructor(
    private salesDistributionService: SalesDistributionService,
    private readonly orederService: PrincipalScreenService,
    private readonly updateOrderService: UpdateOrderService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
   
  }
  
  closeDrawerChild(isAdd: boolean = false){
    this.closeDrawer.emit(isAdd)
  }

  toggleDetails(product: any): void {
    const dataSelectId = product._id + product.position;
    const dataItemId = this.selectedMaterialDoc?._id + this.selectedMaterialDoc?.position;

    if (this.selectedMaterialDoc && dataSelectId === dataItemId) {
      this.closeDetails();
      return;
    }
    this.selectedMaterialDoc = product;
  }
  
  closeDetails(): void {
    this.selectedMaterialDoc = null;
  }

  validateInput(event: any, item: any) {
    let value = event?.toString() || ""; //.target.value;

    // Permite solo números con máximo 3 decimales
    value = value.replace(/[^0-9.]/g, "");

    // Evita múltiples puntos
    value = value.replace(/(\..*?)\..*/g, "$1");

    // Limita a 3 decimales
    value = value.replace(/^(\d*\.\d{0,3}).*$/, "$1");

    // Elimina ceros iniciales innecesarios (excepto antes del punto)
    value = value.replace(/^0+(?=\d)(?!\.)/, "");

    // Si no tiene punto decimal, agrégale ".0"
    if (value && !value.includes(".")) {
      value += ".0";
    }

    let numericValue = parseFloat(value);

    if (item.selectedUnit === UnitOfMeasureEnum.UMB) {
      item.baseQuantity = numericValue;
    } else if (item.selectedUnit === UnitOfMeasureEnum.UMP) {
      item.pararellQuantity = numericValue;
    }
  }

  //#region action
  fetchOrderBySerial(serial: string) {
    if (!serial){
      return;
    }

    this.salesDistributionService.getOrderBySerial(serial).subscribe({
      next: (res: any) => {
        this.detailOrderUnified = [res.data];
        this.openDistributionModalDetails(serial);
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }

  openDistributionModalDetails(serial: string): void {
    this.dialog.open(this.viewDocumentModal, {
      data: {
        serial: serial,
      },
      panelClass: "form-modal-update",
      disableClose: true,
    });
    this.dialogReEdit.afterClosed().subscribe((result) => { });
  }

  onHandleEditUMBDetail(itemSelect) {
    itemSelect.edit = itemSelect.edit ? false : true;

    if (!itemSelect.selectedUnit) {
      itemSelect.selectedUnit = UnitOfMeasureEnum.UMB;
    }

    //this.distributionSpare();
    this.expandedMaterial.orderdetail = [
      ...this.expandedMaterial.orderdetail,
    ];

    this.openModalUnitMeasure(itemSelect)
  }

  openModalUnitMeasure(itemSelect){
    itemSelect._backup = {
      baseQuantity: itemSelect.baseQuantity,
      pararellQuantity: itemSelect.pararellQuantity,
      selectedUnit: itemSelect.selectedUnit,
    };

    this.unitMeasureModalRef = this.dialog.open(this.unitMeasureModal, {
      width: '500px',
      data: itemSelect
    })
  }

  inputCancelUMB(itemSelect: any) {
    //this.distributionSpare();
    if (itemSelect._backup) {
      itemSelect.baseQuantity = itemSelect._backup.baseQuantity;
      itemSelect.pararellQuantity = itemSelect._backup.pararellQuantity;
      itemSelect.selectedUnit = itemSelect._backup.selectedUnit;
      delete itemSelect._backup; // limpiar backup
    }
  
    itemSelect.edit = false;
    this.unitMeasureModalRef?.close();
  }

  inputSaveUMB(itemSelect: any) {
    delete itemSelect._backup;
    itemSelect.edit = itemSelect.edit ? false : true;
    itemSelect.soldQuantity = itemSelect.baseQuantity;
    itemSelect.pararellQuantity =
      itemSelect.baseQuantity * itemSelect.pararellConversionFactor;

    const totalBaseQuantity = +this.expandedMaterial.orderdetail.reduce(
      (sum, item) => sum + (item.baseQuantity || 0),
      0
    );

    const resultMisSper =
      this.expandedMaterial.totalBaseQuantity - totalBaseQuantity;

    if (resultMisSper >= 0) {
      this.expandedMaterial.spare = resultMisSper;
      this.expandedMaterial.missing = 0;
    } else {
      this.expandedMaterial.missing = -resultMisSper;
      this.expandedMaterial.spare = 0;
    }

    if (!itemSelect.edit) {
      if (!itemSelect.selectedUnit) {
        itemSelect.selectedUnit = UnitOfMeasureEnum.UMB;
      }

      this.expandedMaterial.orderdetail = [
        ...this.expandedMaterial.orderdetail,
      ];
    }

    this.fetchupdateOrderLoad({
      _id: itemSelect._id,
      position: itemSelect.position,
      materialId: this.expandedMaterial.material._id,
      quantity: itemSelect.baseQuantity,
      type: itemSelect.selectedUnit ?? UnitOfMeasureEnum.UMB
    }, itemSelect);

    this.unitMeasureModalRef?.close()
  }

  private fetchupdateOrderLoad(data, itemSelect) {
    this.updateOrderService.updateBaseUnit(data).subscribe({
      next: (res: any) => {
        this.snackBar.open("Se actualizo exitosamente el material", "Cerrar", {
          duration: 3000,
        });
        itemSelect.soldQuantity = res.updatedDetail.soldQuantity;
        itemSelect.baseQuantity = res.updatedDetail.baseQuantity;
        itemSelect.pararellQuantity = res.updatedDetail.pararellQuantity;
        this.closeDrawerChild(true)
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }

  openSoldToEmptyDocument() {
    if (!this.expandedMaterial) {
      this.snackBar.open("Debe seleccionar un documento", "Cerrar", { duration: 3000 });
      return;
    }

    let send = {
      entryDeliverySerials: this.expandedMaterial.serial
    }

    this.orederService.getCustomersByDocument(send).subscribe(
      (res) => {
        this.soldToList = res || [];
        this.selectedSoldTo = null;
        this.detail.selectedUnit = null;
        this.soldToEmptyDialogRef = this.dialog.open(this.soldToEmptyDocument, {
          width: '500px'
        });
      });
  }

  saveSoldTo() {
    if (!this.selectedSoldTo || !this.detail.selectedUnit || !this.detail.baseQuantity) {
      this.snackBar.open("Debe seleccionar un cliente y completar los campos requeridos", "Cerrar", { duration: 3000 });
      return;
    }

    const data = {
      eeDocumentDoc: this.expandedMaterial.serial,
      materialId: this.expandedMaterial.material._id,
      esDocument: this.selectedSoldTo.serial,
      quantity: this.detail.selectedUnit == UnitOfMeasureEnum.UMP ? this.detail.pararellQuantity : this.detail.baseQuantity,
      type: this.detail.selectedUnit ?? UnitOfMeasureEnum.UMB
    };

    this.orederService.postCustomerAddDocument(data).subscribe({
      next: (res) => {
        this.snackBar.open("Se guardó exitosamente", "Cerrar", { duration: 3000 });
        this.soldToEmptyDialogRef?.close();
        this.closeDrawerChild(true);
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }
  //#endregion
}
